import { MapPin, Mail, Phone } from "lucide-react";

interface AddressContactCardProps {
  profile: any;
}

export function AddressContactCard({ profile }: AddressContactCardProps) {
  const formatFullAddress = () => {
    const addressParts = [
      profile.address_1,
      profile.address_2,
      profile.postal_code,
      profile.city,
      profile.state,
      profile.country
    ].filter(Boolean);

    return addressParts.length > 0 ? addressParts.join(", ") : null;
  };

  return (
    <div className="bg-white border rounded-lg p-4 shadow-sm">
      <div className="flex items-center gap-2 mb-4">
        <MapPin className="h-5 w-5 text-gray-600" />
        <h3 className="font-semibold text-gray-900">Address & Contact</h3>
      </div>
      <div className="space-y-3">
        {formatFullAddress() && (
          <div className="flex items-start gap-2">
            <MapPin className="h-4 w-4 text-gray-600 mt-0.5 flex-shrink-0" />
            <span className="text-sm text-gray-600">{formatFullAddress()}</span>
          </div>
        )}

        {profile.email && (
          <div className="flex items-center gap-2">
            <Mail className="h-4 w-4 text-gray-600 flex-shrink-0" />
            <span className="text-sm text-gray-600">{profile.email}</span>
          </div>
        )}

        {profile.phone && (
          <div className="flex items-center gap-2">
            <Phone className="h-4 w-4 text-gray-600 flex-shrink-0" />
            <span className="text-sm text-gray-600">{profile.phone}</span>
          </div>
        )}
      </div>
    </div>
  );
}
